export { default } from './UgcWithReviews.vue';